import React, { useState, useEffect } from 'react'
import { Form, Button, Container, Row, Col, Modal, Nav, BreadcrumbItem, Breadcrumb } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { parseUserInfo } from '../../utils/parseUtil'
import { useGetForm22Mutation } from '../../slices/adminApiSlice'

const Form22 = () => {
    const [year, setYear] = useState("")
    const [reportType, setReportType] = useState("")
    const [showModal, setShowModal] = useState(false)
    const [pdfUrl, setPdfUrl] = useState("")
    const [yearsOptions, setYearsOptions] = useState([]);



    const { userInfo } = useSelector((state) => state.auth)

    const [getForm22, { isLoading }] = useGetForm22Mutation()


    useEffect(() => {
        const now = new Date()
        const currentYear = now.getFullYear()

        const startYear = parseInt(process.env.REACT_APP_START_YEAR, 10 || 2020)

        const options = []
        for (let i = startYear; i <= currentYear + 1; i++) {
            options.push(i)
        }

        setYearsOptions(options)
        setYear(currentYear.toString())

    }, [userInfo])


    const handleSubmit = async (e) => {
        e.preventDefault()

        const reqCompanyCode = userInfo[13]?.InfoField

        const formData = new FormData()
        formData.append('title', 'GetFactoryReport22')
        formData.append('description', 'GetYearlyBonusReports')
        formData.append('ReqCompanyCode', reqCompanyCode)
        formData.append('ReqRptType', reportType)
        formData.append('ReqYear', year)


        for (let [key, value] of formData.entries()) {
            console.log(`${key}: ${value}`)
        }


        try {
            const res = await getForm22(formData)

            const parsedData = parseUserInfo(res)

            if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
                const data = parsedData[0]

                if (data.ErrorCode === '0') {
                    let pdfPath = data.JSONData1

                    if (pdfPath.startsWith('/api/WebServiceFactoryReports.aspx/')) {
                        pdfPath = pdfPath.replace('/api/WebServiceFactoryReports.aspx/', '/')
                    }

                    const backendUrl = process.env.REACT_APP_URL
                    const pdfUrl = `${backendUrl}${pdfPath}`

                    setPdfUrl(pdfUrl)
                    setShowModal(true)
                } else {
                    toast.error(data.ErrorMessage || 'An error occurred')
                }
            } else {
                toast.error('Failed to parse user info')
            }
        } catch (err) {
            console.error('Error submitting data:', err)
            toast.error(err?.data?.message || 'Error submitting data')
        }
    }

    return (
        <>
            <Breadcrumb>
                <BreadcrumbItem>
                    <Nav.Link as={Link} to="/dashboard" className='text-success text-decoration-none'>
                        Dashboard
                    </Nav.Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                    Form 22
                </BreadcrumbItem>
            </Breadcrumb>
            <Container className="form-container">
                <h4 className="text-center">Form 22</h4>
                <Form className="border p-4 rounded bg-light mb-4" onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={12}>
                            <Form.Group controlId="year">
                                <Form.Label>Year</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={year}
                                    onChange={(e) => setYear(e.target.value)}
                                    className="form-control-hover"
                                    required
                                >
                                    {yearsOptions.map((yr) => (
                                        <option key={yr} value={yr}>
                                            {yr}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col className='radio-box'>
                            <Form.Group>
                                <Form.Label><div className="headline">Report Type</div></Form.Label>
                                <div className="d-flex">
                                    <Form.Check
                                        type="radio"
                                        id="firstHalf"
                                        name="reportType"
                                        label="First Half"
                                        value="0"
                                        checked={reportType === "0"}
                                        onChange={(e) => setReportType(e.target.value)}
                                        className="mx-3"
                                    />
                                    <Form.Check
                                        type="radio"
                                        id="secondHalf"
                                        name="reportType"
                                        label="Second Half"
                                        value="1"
                                        checked={reportType === "1"}
                                        onChange={(e) => setReportType(e.target.value)}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center">
                            <Button
                                type="submit"
                                variant="primary"
                                className="px-4"
                            >
                                Print
                            </Button>
                        </Col>
                    </Row>
                </Form>

                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Form 22</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <iframe
                            src={pdfUrl}
                            width="100%"
                            height="500px"
                            title="Form 22"
                        ></iframe>
                    </Modal.Body>
                </Modal>
            </Container>
        </>
    )
}

export default Form22
